<template>
    <page :busy="busy">
        <grid
            ref="grid"
            :column-defs="columnDefs"
            :fetch-callback="fetchCallback"
            :is-auto-width="true"
            :getRowStyle="rowStyle"
            :isSearch="true"
            :buttonToolbarClass="['align-items-start flex-md-nowrap']"
            :defaultSort="sort"
            :defaultDesc="true"
        >
            <responsive-button :icon="['fas', 'arrows-rotate']" @click="refresh" variant="primary"
                >Refresh</responsive-button
            >
            <responsive-button :icon="['fas', 'plus']" variant="primary" @click="onCreate">Create Campaign</responsive-button>
        </grid>
    </page>
</template>

<script>
    import API from '../../../api';
    import { MASS_PUSH_NOTIFICATION_ENDPOINT } from '../../../endpoints';
    import page from '../../generic/page/page.vue';
    import Grid from '../../generic/grid/grid.vue';
    import ResponsiveButton from '../../generic/responsive-button/responsive-button.vue';
    import ResponsiveDropdown from '../../generic/responsive-dropdown/responsive-dropdown.vue';
    import MassPushNotificationActionCellRenderer from './mass-push-notification-action-cell-renderer.vue';

    export default {
        components: {
            page,
            Grid,
            ResponsiveButton,
            ResponsiveDropdown,
            massPushNotificationActionCellRenderer: MassPushNotificationActionCellRenderer,
        },
        name: 'MassPushNotificationActionList',
        data() {
            return {
                busy: false,
                columnDefs: [
                    {
                        field: 'id',
                        headerName: 'ID',
                        type: 'textColumn',
                        minWidth: 100,
                    },
                    {
                        field: 'created',
                        headerName: 'Created',
                        type: 'dateTimeColumn',
                        minWidth: 175,
                    },
                    {
                        field: 'title',
                        headerName: 'Title',
                        type: 'textColumn',
                        minWidth: 200,
                    },
                    {
                        field: 'message',
                        headerName: 'Message',
                        type: 'textColumn',
                        autoWidthExclude: true,
                    },
                    {
                        field: 'status',
                        headerName: 'Status',
                        type: 'textColumn',
                        minWidth: 100,
                    },
                    {
                        field: 'delivered_count',
                        headerName: 'Delivered',
                        type: 'textColumn',
                        minWidth: 100,
                        sortable: false,
                    },
                    {
                        field: 'failed_count',
                        headerName: 'Failed',
                        type: 'textColumn',
                        minWidth: 100,
                        sortable: false,
                    },
                    {
                        headerName: 'Actions',
                        minWidth: 100,
                        resizable: false,
                        sortable: false,
                        cellStyle: { textAlign: 'center' },
                        cellRenderer: 'massPushNotificationActionCellRenderer',
                        cellRendererParams: {},
                    },
                ],
                rowStyle: null,
                offset: 0,
                limit: 20,
                sort: 'id',
                desc: false,
                search: '',
            };
        },
        computed: {
            pinnedBottomRowData() {
                return [{}];
            },
            fetchCallback() {
                return ({ offset, limit, sort, desc, search }) => {
                    this.offset = offset;
                    this.limit = limit;
                    this.sort = sort;
                    this.desc = desc;
                    this.search = search;
                    return API.get(`${MASS_PUSH_NOTIFICATION_ENDPOINT()}grid/`, {
                        params: {
                            offset,
                            limit,
                            sort,
                            desc,
                            search,
                        },
                    });
                };
            },
        },
        mounted() {
            //
        },
        methods: {
            onCreate() {
                this.$router.push(`/app/staylio-app/mass-push-notification/create/`);
            },
            refresh() {
                this.$refs.grid?.refreshDataSource();
            },
        },
    };
</script>

<style lang="scss" scoped></style>
